import { useState } from 'react'

// import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import { Box, Container } from '@mui/material'

import SubPageHeader from 'components/SubPageHeader'

import { styles } from './Support.styles'
import SupportAccordion from './components/SupportAccordion'
import { FAQCategories } from './constants/FAQ'

export const Support = () => {
	const [activeFAQDropdown, setActiveFAQDropdown] = useState<number>(-1)
	return (
		<Box>
			<SubPageHeader
				title="Support Resources"
				subtitle="How to get the most out of Brainstorm to maximize your team's innovative potential"
				backgroundGradient="linear-gradient(90deg, #9DCDF2 0%, #BDDEF6 100%)"
			/>
			<Container maxWidth={false} sx={styles.container}>
				{/* Commented out search bar to be implemented in the future */}
				{/* <Box sx={{ mb: 1, mt: 4 }}>
                    <span style={{ fontSize: 18, fontWeight: 400 }}>
                        Get a quick answer to your question by asking GenAI:
                    </span>
                </Box> */}
				{/* <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'stretch', sm: 'center' },
                        gap: { xs: 2, sm: 2 },
                        mb: 4,
                        py: 1,
                        width: '100%',
                        maxWidth: '100%',
                    }}
                >
                    <Box
                        component="input"
                        type="text"
                        placeholder="Ask AI a question about the support content ..."
                        sx={{
                            width: '80%',
                            flex: 'none',
                            height: 46,
                            border: '1px solid #ccc',
                            borderRadius: '6px',
                            px: 2,
                            fontSize: { xs: 15, sm: 16 },
                            background: '#fff',
                            mb: { xs: 1, sm: 0 },
                            boxSizing: 'border-box',
                            '::placeholder': {
                                color: '#b0b0b0',
                                opacity: 1,
                            },
                        }}
                        disabled
                    />
                    <Box
                        component="button"
                        disabled
                        sx={{
                            width: { xs: '100%', sm: 'auto' },
                            height: 46,
                            px: { xs: 0, sm: 3 },
                            borderRadius: '6px',
                            border: '1px solid #ccc',
                            background: '#f5f5f5',
                            color: '#888',
                            fontWeight: 600,
                            fontSize: 14,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 1,
                            cursor: 'not-allowed',
                        }}
                    >
                        <span
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginRight: 0,
                            }}
                        >
                            <AutoAwesomeIcon />
                        </span>
                        ASK AI
                    </Box>
                </Box> */}

				<Box sx={styles.helpText} data-testid="support-message">
					<span style={styles.helpTextSpan}>
						Need help from our team? Reach out anytime and
						we&apos;ll be in touch within 24 hours on business days.
					</span>
				</Box>

				<Box>
					<Box
						component="a"
						href="https://go.slalom.com/brainstorm-support"
						target="_blank"
						rel="noopener noreferrer"
						sx={styles.requestButton}
						data-testid="live-support-button"
					>
						REQUEST LIVE SUPPORT
					</Box>
				</Box>
				<Box>
					{/* Accordion Dropdown */}
					<Box sx={styles.accordionContainer}>
						{Object.values(FAQCategories).map((category, index) => (
							<Box
								key={category}
								data-testid={`faq-category-${category}`}
							>
								<SupportAccordion
									dropdownId={index}
									activeFAQDropdown={activeFAQDropdown}
									setActiveFAQDropdown={setActiveFAQDropdown}
									category={category}
								/>
							</Box>
						))}
					</Box>
				</Box>
			</Container>
		</Box>
	)
}

export default Support
